import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import './index.css';

// Import Swiper styles
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
